export const appEnv = process.env.NEXT_PUBLIC_ENV || 'unknown'
export const appVersion = process.env.NEXT_PUBLIC_COMMIT_SHA?.substring(0, 7) ?? 'unspecified'
export const appSemVersion = process.env.NEXT_PUBLIC_VERSION_TAG
